import React from 'react';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../../_virtual/moment.js';
import '../../../chat_context.js';
import { useChatApi } from '../../../hooks/use_chat_api.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';

const useChatMemberAbility = (channel) => {
    const api = useChatApi();
    const [ability, setAbility] = React.useState({
        canDelete: false,
        canUpdate: false,
    });
    React.useEffect(() => {
        api.chat
            .get(`/me/conversations/${channel.id}/member_ability`)
            .then((data) => setAbility({
            canDelete: data.can_delete,
            canUpdate: data.can_update,
        }));
    }, [channel]);
    return ability;
};

export { useChatMemberAbility };
//# sourceMappingURL=use_chat_member_ability.js.map
